import { PhoneNumber } from './../phone';

export interface FitterContact {
  name: string;
  email: string;
  activeEmail: boolean;
  phone: PhoneNumber;
  activePhone: boolean;
}
